import { gql } from "@apollo/client";

const GET_HEI_NOMINATIONS = gql`
query hei($erasmusCode: String)
    {hei (erasmusCode: $erasmusCode) {
        erasmusCode
        country
        name
        heiID
    }  
}`
;

export default GET_HEI_NOMINATIONS;
